/* eslint-disable react/jsx-handler-names */
import { $FixMe } from '@eventbrite/ts-utils';
import loadable from '@loadable/component';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { CUSTOM_DATE } from '../../../../constants';
import { FOLLOWED_ORGS_FILTER_VALUE } from '../../../../constants/filters';
import {
    handleApplyFilter as handleApplyFilterAction,
    handleRemoveAllFilters as handleRemoveAllFiltersAction,
    handleRemoveFilter as handleRemoveFilterAction,
    handleRemoveOnlineFilter,
    searchByBBoxOrPlace as searchByBBoxOrPlaceAction,
} from '../../../../redux/actions/search';
import {
    openCloseAnimatedDrawer as openCloseAnimatedDrawerAction,
    setFilterTypeToShow as setFilterTypeToShowAction,
} from '../../../../redux/actions/ui';
import {
    getSelectedCategory,
    getSelectedDate,
    getSelectedFilterCount,
    getSelectedFormat,
} from '../../../../redux/selectors/search';
import { DiscoverState } from '../../../../types';
//todo: properly handle loadable once experiment concluded
import { FilterPanelDesktop } from '../../components/FilterPanel/FilterPanelDesktop';
import { FilterPanelMobile } from '../../components/FilterPanel/FilterPanelMobile';
import { FilterHeaderContainer } from '../FilterHeaderContainer/FilterHeaderContainer';
import { trackFiltersForStatsig } from './analytics';
import './FilterPanelContainer.scss';

const BotFilters = loadable(() => import('../../components/BotFilters'), {
    resolveComponent: (component: { BotFilters: React.ReactNode }) =>
        component.BotFilters,
});

interface FilterPanelProps {
    /**
     * Callbacks for when filters are applied
     */
    handleApplyFilter?: Function;
    handleRemoveFilter?: Function;
    /**
     * Boolean for if mobile filter panel should be displayed
     */
    isAnimatedDrawerOpen?: boolean;
    selectedFilterCount?: number;
    openCloseAnimatedDrawer?: Function;
    selectedFilters?: $FixMe;
    locationSlug?: string;
    isBotRequest?: boolean;
    handleRemoveAllFilters?: Function;
    isAuthenticated?: boolean;
    isLoading?: boolean;
    languageCode?: string;
    handleApplyOnlineFilter?: Function;
    handleRemoveOnlineFilter?: Function;
    location: Location;
    filterTypeToShow?: string;
}

export const FilterPanel: React.FunctionComponent<FilterPanelProps> = (
    props,
) => {
    const {
        selectedFilterCount,
        handleApplyFilter,
        handleRemoveFilter,
        isAnimatedDrawerOpen,
        openCloseAnimatedDrawer,
        selectedFilters,
        locationSlug,
        isBotRequest,
        handleRemoveAllFilters,
        isAuthenticated,
        isLoading,
        languageCode,
        handleApplyOnlineFilter,
        handleRemoveOnlineFilter,
        location,
    } = props;

    const handleChange = React.useCallback(
        (key: string, value: string) => {
            trackFiltersForStatsig(key);
            handleApplyFilter?.({ [key]: value }, {});
        },
        [handleApplyFilter],
    );

    const handleCustomDate = React.useCallback(
        (startDate: string, endDate: string) => {
            handleApplyFilter?.({ dates: CUSTOM_DATE }, { startDate, endDate });
        },
        [handleApplyFilter],
    );

    const SHARED_FILTER_PROPS = {
        isAuthenticated,
        location,
        languageCode,
        selectedFilterCount: selectedFilterCount,
        selectedFilters: selectedFilters,
        isLoading: isLoading,
        handleRemoveAllFilters: handleRemoveAllFilters,
        handleRemoveFilter,
        handleApplyOnlineFilter,
        handleRemoveOnlineFilter,
        onFilterChange: handleChange,
        onCustomDateChange: handleCustomDate,
    };

    return (
        <>
            <aside
                className="filter-panel-desktop-container"
                data-testid="filter-panel-desktop-container"
            >
                {isBotRequest ? (
                    <div className="filter-panel">
                        <BotFilters slug={props.locationSlug} />
                    </div>
                ) : (
                    <FilterPanelDesktop
                        {...SHARED_FILTER_PROPS}
                        locationSlug={locationSlug || ''}
                        isMobile={false}
                    />
                )}
            </aside>
            {isAnimatedDrawerOpen && (
                <div>
                    <FilterPanelMobile
                        {...SHARED_FILTER_PROPS}
                        isMobile={true}
                        filterTypeToShow={props.filterTypeToShow}
                        openCloseAnimatedDrawer={openCloseAnimatedDrawer}
                        headerChildren={
                            <FilterHeaderContainer
                                hideActiveFilterLabel={true}
                                shouldRenderInactivePills={false}
                            />
                        }
                    />
                    <style
                        /* eslint-disable-next-line react/no-danger */
                        dangerouslySetInnerHTML={{
                            __html: `
                                .eds-structure {
                                    position: fixed;
                                    width: 100%;
                                    height: 100%;
                                }
                            `,
                        }}
                    />
                </div>
            )}
        </>
    );
};

const _mapStateToProps = (state: DiscoverState) => ({
    selectedFilterCount: getSelectedFilterCount(state),
    isAnimatedDrawerOpen: state.ui.isAnimatedDrawerOpen,
    filterTypeToShow: state.ui.filterTypeToShow,
    isBotRequest: state.app.isBotRequest,
    locationSlug: state.location.slug,
    isAuthenticated: state.auth.isAuthenticated,
    languageCode: state.app.languageCode,
    selectedFilters: {
        price: state.search.eventSearch.price,
        tags: getSelectedCategory(state.search.eventSearch.tags),
        format: getSelectedFormat(state.search.eventSearch.tags),
        dates: getSelectedDate(
            state.search.eventSearch.dates,
            state.search.eventSearch.dateRange,
        ),
        currencies:
            state.search.eventSearch.currencies.length > 0
                ? state.search.eventSearch.currencies[0]
                : '',
        languages:
            state.search.eventSearch.languages.length > 0
                ? state.search.eventSearch.languages
                : '',
        followedOrganizers:
            state.search.eventSearch.special &&
            state.search.eventSearch.special?.indexOf(
                FOLLOWED_ORGS_FILTER_VALUE,
            ) > -1,
        organizations: state.search.eventSearch?.organizationsOr
            ? state.search.eventSearch.organizationsOr
            : [],
        hash: state.search.eventSearch.hash,
        isOnline: state.search.eventSearch.onlineEventsOnly,
    },
});

const _mapDispatchToProps = (
    dispatch: Function,
    ownProps: { history: any },
) => ({
    handleApplyFilter: (...args: [$FixMe]) =>
        dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleRemoveFilter: (...args: [$FixMe]) =>
        dispatch(handleRemoveFilterAction(ownProps.history || {}, ...args)),
    handleRemoveAllFilters: (...args: [$FixMe]) =>
        dispatch(handleRemoveAllFiltersAction(ownProps.history, ...args)),
    openCloseAnimatedDrawer: (...args: [$FixMe]) =>
        dispatch(openCloseAnimatedDrawerAction(...args)),
    setFilterTypeToShowAction: (...args: [$FixMe]) =>
        dispatch(setFilterTypeToShowAction(...args)),
    handleApplyOnlineFilter: (...args: [$FixMe]) =>
        dispatch(searchByBBoxOrPlaceAction(ownProps.history, ...args)),
    handleRemoveOnlineFilter: (...args: [$FixMe]) =>
        dispatch(handleRemoveOnlineFilter(ownProps.history, ...args)),
});

const enhance = compose<any>(
    withRouter,
    connect(_mapStateToProps, _mapDispatchToProps),
);

export const FilterPanelContainer = enhance(FilterPanel);
